import { render, staticRenderFns } from "./PriceTrendSection.vue?vue&type=template&id=0b2f55ce&scoped=true"
import script from "./PriceTrendSection.vue?vue&type=script&lang=ts"
export * from "./PriceTrendSection.vue?vue&type=script&lang=ts"
import style0 from "./PriceTrendSection.vue?vue&type=style&index=0&id=0b2f55ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f55ce",
  null
  
)

export default component.exports